import BackHomeLink from './BackHomeLink';

export default BackHomeLink;
